import { BrowserModule } from '@angular/platform-browser'
import { NgModule, ErrorHandler } from '@angular/core'
import { RouterModule } from '@angular/router'
import { HttpClientModule } from '@angular/common/http'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { CookieModule } from 'ngx-cookie'
import {
  SeButtonModule,
  SeEmptyStateModule,
  SeIconModule,
  SeMembershipCardModule,
  SeTagModule,
  SePersonaAvatarModule
} from '@se-ui-components'

import { routes } from './routes'
import { ComponentsModule } from './components/components.module'
import { LayoutModule } from './layout/layout.module'

import { AppComponent } from './app.component'
import { NotFoundComponent } from './error/not-found.component'
import { PostCheckoutComponent } from './post-checkout/post-checkout.component'
import { VerifyComponent } from './verify/verify.component'

import {
  AppErrorHandler,
  CardService,
} from './services'

import { CardDownloadComponent } from './download/card-download.component'
import { CardDownloadDirective } from './download/card-download.directive'
import { CredentialItemComponent } from './verify/credential-item/credential-item.component'
import { CredentialListItemComponent } from './verify/credential-list-item/credential-list-item.component'
import { MembershipItemComponent } from './verify/membership-item/membership-item.component'
import { SeAnalyticsService } from './services/se-analytics.service'
import { PostAssignmentsComponent } from './post-assignments/post-assignments.component'

@NgModule({
  declarations: [
    AppComponent,
    CardDownloadComponent,
    CardDownloadDirective,
    CredentialItemComponent,
    CredentialListItemComponent,
    MembershipItemComponent,
    NotFoundComponent,
    PostAssignmentsComponent,
    PostCheckoutComponent,
    VerifyComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    ComponentsModule,
    CookieModule.forRoot(),
    HttpClientModule,
    LayoutModule,
    SeButtonModule,
    SeEmptyStateModule,
    SeIconModule,
    SeMembershipCardModule,
    SePersonaAvatarModule,
    SeTagModule,
    RouterModule.forRoot(routes),
  ],
  providers: [
    CardService,
    { provide: ErrorHandler, useClass: AppErrorHandler },
    SeAnalyticsService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
